<div class="accordion-item">
  <h2 class="accordion-header" [id]="id">
    <button
      class="accordion-button"
      [class.collapsed]="!isExpanded"
      [class.arrow-toggle-only]="arrowToggleOnly"
      type="button"
      [attr.aria-expanded]="isExpanded"
      [attr.aria-controls]="id + '-panel'"
      (click)="toggle($event)"
      [disabled]="disabled"
      [title]="tooltipText"
    >
      {{ title }}<ng-template *ngTemplateOutlet="titleContent"></ng-template>
      <button class="accordion-chevron" (click)="toggle($event, true)"></button>
    </button>
  </h2>
  <div
    [id]="id + '-section'"
    class="accordion-collapse collapse"
    [class.show]="isExpanded"
    [attr.aria-labelledby]="id"
    *ngIf="isExpanded"
    @collapse
  >
    <div class="accordion-body">
      <ng-template *ngTemplateOutlet="templateContent"></ng-template>
      <ng-content></ng-content>
    </div>
  </div>
</div>
